import { extendTheme } from "@chakra-ui/react";

// Custom theme definition with jewel tones
export const emptyTheme = extendTheme({
  config: {},
  colors: {},
  fonts: {},
  styles: {},
  components: {},
});
